import {gsap} from "gsap";

const Extender = {

    init() {
        this.el = $('[component="Extender"]');
        if (!this.el.length) return;

        this.el.each((i, el) => {
            this.prepare($(el));
        })
    },

    prepare(el) {
        if (el.innerHeight() <= parseInt(el.data('height')) + 50) return;

		const button = $('<span>')
			.attr('icon', el.data('open-icon'))
			.text(T[el.data('open-text')])


        $('<div class="handle"></div>')
            .html(button)
            .appendTo(el);

        el.css('height', el.data('height'));
        this.bind(el);
    },

    bind(component) {
        component.find('.handle').click((evt) => {
            const el = $(evt.currentTarget);
            if (el.is('.active')) {
                this.hide(component);
            } else {
                this.show(component);
            }
        })
    },

    show(el) {
        el.find('.handle').addClass('active')
			.find('span')
            .attr('icon', el.data('close-icon'))
            .text(T[el.data('close-text')])

        gsap.set(el, {height: 'auto'})
        gsap.from(el, {height: el.data('height'), clearProps: true})
    },

    hide(el) {
        el.find('.handle').removeClass('active')
			.find('span')
            .attr('icon', el.data('open-icon'))
            .text(T[el.data('open-text')])

        gsap.to(el, {height: el.data('height')})
    }
}

export default Extender;